import apiClient from '@/api/index'

export default {
  index (rapperId, params) {
    return apiClient.get(`/rappers/${rapperId}/media`, { params })
  },
  store (rapperId, formData) {
    return apiClient.post(`/rappers/${rapperId}/media`, formData)
  },
  show (rapperId, mediaId, params) {
    return apiClient.get(`/rappers/${rapperId}/media/${mediaId}`, { params })
  },
  update (rapperId, mediaId, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/rappers/${rapperId}/media/${mediaId}`, formData)
  },
  destroy (rapperId, mediaId) {
    return apiClient.delete(`/rappers/${rapperId}/media/${mediaId}`)
  }
}
